"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _PrivateRoute = _interopRequireDefault(require("./PrivateRoute"));
var _views = require("../views");
var _actions = require("../actions");
var _redux = require("redux");
var _OptinChallenge = _interopRequireDefault(require("./OptinChallenge"));
var _awsAmplify = require("aws-amplify");
var _actionTypes = require("../actionTypes");
var _components = require("../../../components");
var _MaintenanceMode = _interopRequireDefault(require("./MaintenanceMode"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultComponents = {
  NotFound: /*#__PURE__*/_react.default.createElement("span", null, "Default NotFound component."),
  NewPassword: _views.NewPassword,
  ResetPassword: _views.ResetPassword,
  MFARequired: /*#__PURE__*/_react.default.createElement("span", null, "Default MFARequired component."),
  ConfirmationRequired: /*#__PURE__*/_react.default.createElement("span", null, "Default ConfirmationRequired component."),
  UnrecognisedState: /*#__PURE__*/_react.default.createElement("span", null, "Default UnrecognisedState component.")
};
const mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};
const mapDispatchToProps = dispatch => {
  return (0, _redux.bindActionCreators)({
    deleteSession: _actions.deleteSession,
    createSession: _actions.createSession,
    getSession: _actions.getSession,
    signOut: _actions.signOut,
    quit: _actions.quit,
    dispatch
  }, dispatch);
};
const CustomChallenge = props => {
  switch (props.challenge.type) {
    case _actionTypes.OPTIN_CHALLENGE:
      return /*#__PURE__*/_react.default.createElement(_OptinChallenge.default, {
        data: props.challenge.data,
        onClick: body => props.challenge.respond({
          optin: body,
          challenge: props.challenge
        })
      });
    default:
      return /*#__PURE__*/_react.default.createElement("div", null, "CUSTOM_CHALLENGE DEFAULT");
  }
};
class Authenticator extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "authenticate", () => {
      const {
        auth,
        history,
        dispatch,
        location,
        routes
      } = this.props;
      // if (auth.state !== "LOGGED_IN") return true;
      return dispatch(_actions.authenticate).then(response => {
        dispatch(() => (0, _actions.getMe)({
          expand: "FlatPermissions,UserImage"
        })).then(() => {
          // dont call optins earlier otherwise a slower getMe request will overwrite state

          if (auth.onAuthenticateSuccess) auth.onAuthenticateSuccess({
            history,
            location,
            dispatch
          }, response);
        }).catch(err => {
          console.dir(err);
        });
      }).catch(err => {
        for (let i = 0; i < routes.length; i++) {
          if (routes[i].path === location.pathname && !routes[i].private) {
            return true;
          }
        }
        console.dir(err);
        return history.push(auth.onUnauthorizedRedirect);
      });
    });
  }
  UNSAFE_componentWillMount() {
    const {
      components
    } = this.props;
    Object.entries(defaultComponents).map(([key]) => {
      this[key] = components && components[key] ? components[key] : defaultComponents[key];
    });
  }
  async componentDidMount() {
    const {
      auth,
      history,
      location
    } = this.props;
    if (auth.state !== "LOGGED_IN") {
      try {
        const cognitoSession = await _awsAmplify.Auth.currentSession();
        this.props.getSession(cognitoSession.idToken.jwtToken);
      } catch (e) {
        console.log(e);
        //HACK dont redirect on some routes, could be configurable, not worth it atm
        const noRedirectPaths = ["/sign-in", "/sign-up", "/forgot-password", "/post-sign-up", "/new-password", "/ssoauth"];
        if (!noRedirectPaths.some(p => p.startsWith(location.pathname))) {
          history.push("/sign-in");
        }
      }
    }
  }
  componentDidUpdate(prevProps) {
    const {
      auth,
      location,
      history
    } = this.props;
    const {
      session,
      me
    } = auth;
    if (prevProps.auth.session !== session) {
      if (session.data) {
        //found existing session or created one, trying me request
        this.authenticate();
      }
    }
    if (prevProps.auth.me !== me) {
      if (me.failed) {
        //Me Request failed probably no session/new session -> quit
        this.props.quit();
        history.push("/sign-in");
      }
    }
  }
  render() {
    const {
      routes,
      auth,
      history,
      location,
      components,
      generalSettings
    } = this.props;
    const NewPassword = components.NewPassword || defaultComponents.NewPassword;
    const ResetPassword = components.ResetPassword || defaultComponents.ResetPassword;
    const MFARequired = components.MFARequired || defaultComponents.MFARequired;
    const ConfirmationRequired = components.ConfirmationRequired || defaultComponents.ConfirmationRequired;
    const UnrecognisedState = components.UnrecognisedState || defaultComponents.UnrecognisedState;
    const publicRoutes = routes.filter(r => !r.private);
    const privateRoutes = routes.filter(r => !r.private !== true).filter(r => auth.me.helpers.isAllowed(r.restricted));
    if (!auth) {
      console.error("Not auth store registered.");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "alert alert-danger"
      }, "Not auth store registered.");
    }
    switch (auth.state) {
      case _actionTypes.AUTHENTICATED:

      /* falls through */

      case _actionTypes.LOGGING_IN:
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            margin: "0",
            position: "absolute",
            top: "50%",
            left: "50%"
          }
        }, /*#__PURE__*/_react.default.createElement(_components.Spinner, null)));
      case _actionTypes.LOGGED_IN:
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, !!publicRoutes.length && publicRoutes.map((route, index) => {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
            exact: true,
            key: index,
            path: route.path,
            component: route.component
          });
        }), !!privateRoutes.length && privateRoutes.map((route, index) => {
          return /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
            exact: true,
            key: index,
            path: route.path,
            auth: auth,
            location: location,
            component: route.component,
            redirect: auth.onSignOutRedirect,
            generalSettings: generalSettings
          });
        }));
      case _actionTypes.LOGGED_OUT:

      /* falls through */

      case _actionTypes.LOGIN_FAILURE:

      /* falls through */

      case _actionTypes.EMAIL_VERIFICATION_REQUIRED:
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, !!publicRoutes.length && publicRoutes.map((route, index) => {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
            exact: true,
            key: index,
            path: route.path,
            component: route.component
          });
        }));
      case _actionTypes.MFA_REQUIRED:
        return /*#__PURE__*/_react.default.createElement(MFARequired, {
          location: location,
          history: history
        });
      case _actionTypes.NEW_PASSWORD_REQUIRED:
        return /*#__PURE__*/_react.default.createElement(NewPassword, {
          location: location,
          history: history
        });
      case _actionTypes.PASSWORD_RESET_REQUIRED:
        return /*#__PURE__*/_react.default.createElement(ResetPassword, {
          location: location,
          history: history
        });
      case _actionTypes.CONFIRMATION_REQUIRED:
        return /*#__PURE__*/_react.default.createElement(ConfirmationRequired, {
          location: location,
          history: history
        });
      case _actionTypes.CUSTOM_CHALLENGE:
        return /*#__PURE__*/_react.default.createElement(CustomChallenge, {
          challenge: {
            ...auth.challenges[auth.challenges.length - 1],
            userId: auth.me.Id
          }
        });
      case _actionTypes.MAINTENANCE_MODE:
        if (location.pathname === "/imprint") {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, !!publicRoutes.length && publicRoutes.map((route, index) => {
            return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
              exact: true,
              key: index,
              path: route.path,
              component: route.component
            });
          }));
        } else {
          return /*#__PURE__*/_react.default.createElement(_MaintenanceMode.default, null);
        }
      default:
        return /*#__PURE__*/_react.default.createElement(UnrecognisedState, null);
    }
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Authenticator));
module.exports = exports.default;